import { getAnchorableNodesQuery as _getAnchorableNodesQuery } from "./ricos-content-query/index.js";
import {
  isRichContent as _isRichContent,
  isRichContentEmpty as _isRichContentEmpty
} from "./ricos-content/index.js";
import {
  getPluginData as _getPluginData,
  getText as _getText
} from "./ricos-content/lib/content-application.js";
import { setupContentBuilder as _setupContentBuilder } from "./ricos-content/lib/content.js";
import {
  fromPlainText as _fromPlainText,
  toPlainText as _toPlainText
} from "./ricos-content/lib/converters.js";
import { createEmptyContent as _createEmptyContent } from "./ricos-content/lib/create-empty-content.js";
import { extract as _extract } from "./ricos-content/lib/extract.js";
import { getContentLength as _getContentLength } from "./ricos-content/lib/get-content-length.js";
import { isRichContentEqual as _isRichContentEqual } from "./ricos-content/lib/is-rich-content-equal.js";
import { ensureContentId as _ensureContentId } from "./ricos-content/lib/metadata-utils.js";
import { modify as _modify } from "./ricos-content/lib/modify.js";
import {
  createParagraphNode as _createParagraphNode,
  createTextNode as _createTextNode,
  initializeMetadata as _initializeMetadata
} from "./ricos-content/lib/node-utils.js";
import {
  fromCKEditorHtml as _fromCKEditorHtml,
  fromRichTextHtml as _fromRichTextHtml,
  toHtml as _toHtml
} from "./ricos-content/lib/server-side-converters.js";
import { toPlainTextSync as _toPlainTextSync } from "./ricos-content/lib/to-plain-text-sync.js";
import {
  translateContent as _translateContent,
  toTranslatables as _toTranslatables
} from "./ricos-content/lib/translate.js";
import {
  getCountableNodes as _getCountableNodes,
  truncateContent as _truncateContent
} from "./ricos-content/lib/truncate-content.js";
import { truncateRichContent as _truncateRichContent } from "./ricos-content/lib/truncate-rich-content.js";
import { getMediaData as _getMediaData } from "./ricos-content/RicosContentAPI/get-media-data.js";
import { getInitialLinkData as _getInitialLinkData } from "./_shared/link/get-initial-link-data.js";
import { convertToGalleryItemList as _convertItemData } from "./_shared/media/convert-to-gallery-item-list.js";
import {
  RicosEditorApiContext as _RicosEditorApiContext,
  RicosEditorApiProvider as _RicosEditorApiProvider,
  useRicosEditorApi as _useRicosEditorApi,
  withRicosEditorApi as _withRicosEditorApi
} from "./_shared/ricos-editor-api-context/ricos-editor-api-context.js";
import {
  pluginAudio as _pluginAudio
} from "./plugin-audio/index.js";
import {
  pluginAudio as _pluginAudioViewer
} from "./plugin-audio/viewer.js";
import {
  pluginLinkButton as _pluginLinkButton,
  pluginActionButton as _pluginActionButton
} from "./plugin-button/index.js";
import {
  pluginActionButton as _pluginActionButtonViewer,
  pluginLinkButton as _pluginLinkButtonViewer
} from "./plugin-button/viewer.js";
import { pluginCodeBlock as _pluginCodeBlockViewer } from "./plugin-code-block/viewer.js";
import { pluginCollapsibleList as _pluginCollapsibleListViewer } from "./plugin-collapsible-list/viewer.js";
import {
  pluginDivider as _pluginDivider
} from "./plugin-divider/index.js";
import {
  pluginDivider as _pluginDividerViewer
} from "./plugin-divider/viewer.js";
import {
  pluginEmoji as _pluginEmoji
} from "./plugin-emoji/index.js";
import { pluginEmoji as _pluginEmojiViewer } from "./plugin-emoji/viewer.js";
import { pluginFileUpload as _pluginFileUploadViewer } from "./plugin-file-upload/viewer.js";
import { pluginFontFamily as _pluginFontFamilyViewer } from "./plugin-font-family/viewer.js";
import { pluginGallery as _pluginGalleryViewer } from "./plugin-gallery/viewer.js";
import {
  pluginGiphy as _pluginGiphy
} from "./plugin-giphy/index.js";
import { pluginGiphy as _pluginGiphyViewer } from "./plugin-giphy/viewer.js";
import {
  pluginHashtag as _pluginHashtag
} from "./plugin-hashtag/index.js";
import {
  pluginHashtag as _pluginHashtagViewer
} from "./plugin-hashtag/viewer.js";
import {
  pluginHeadings as _pluginHeadings
} from "./plugin-headings/index.js";
import { pluginHtml as _pluginHtmlViewer } from "./plugin-html/viewer.js";
import { pluginImage as _pluginImage } from "./plugin-image/index.js";
import { pluginImage as _pluginImageViewer } from "./plugin-image/viewer.js";
import { pluginIndent as _pluginIndentViewer } from "./plugin-indent/viewer.js";
import { pluginLineSpacing as _pluginLineSpacingViewer } from "./plugin-line-spacing/viewer.js";
import { pluginLinkPreview as _pluginLinkPreview } from "./plugin-link-preview/index.js";
import { pluginLinkPreview as _pluginLinkPreviewViewer } from "./plugin-link-preview/viewer.js";
import { pluginLink as _pluginLinkViewer } from "./plugin-link/viewer.js";
import { pluginMentions as _pluginMentionsViewer } from "./plugin-mentions/viewer.js";
import { pluginShape as _pluginShapeViewer } from "./plugin-shape/viewer.js";
import { pluginSmartBlock as _pluginSmartBlockViewer } from "./plugin-smart-block/viewer.js";
import { pluginPoll as _pluginPollViewer } from "./plugin-social-polls/viewer.js";
import {
  initSpoilersContentState as _initSpoilersContentState,
  pluginSpoiler as _pluginSpoilerViewer,
  SpoilerViewerWrapper as _SpoilerViewerWrapper
} from "./plugin-spoiler/viewer.js";
import {
  pluginTable as _pluginTable
} from "./plugin-table/index.js";
import {
  pluginTable as _pluginTableViewer
} from "./plugin-table/viewer.js";
import {
  pluginTextColor as _pluginTextColor,
  pluginTextHighlight as _pluginTextHighlight
} from "./plugin-text-color/index.js";
import {
  pluginTextColor as _pluginTextColorViewer,
  pluginTextHighlight as _pluginTextHighlightViewer
} from "./plugin-text-color/viewer.js";
import { pluginToc as _pluginTocViewer } from "./plugin-toc/viewer.js";
import { pluginVerticalEmbed as _pluginVerticalEmbedViewer } from "./plugin-vertical-embed/viewer.js";
import { pluginVideo as _pluginVideoViewer } from "./plugin-video/viewer.js";
import { RicosEditor as _RicosEditor } from "./next-runtime.js";
import {
  SchemaDecoration_Type,
  RichContent,
  RicosDocumentNodeType,
  AppEmbedData_AppType,
  ButtonData_Type,
  CollapsibleListData_Direction,
  CollapsibleListData_InitialExpandedItems,
  DividerData_Alignment,
  DividerData_LineStyle,
  DividerData_Width,
  FontSizeData_fontType,
  GalleryOptions_ItemStyle_Crop,
  GalleryOptions_Layout_Orientation,
  GalleryOptions_Layout_Type,
  GalleryOptions_Thumbnails_Alignment,
  GIFData_GIFType,
  HTMLData_Source,
  LayoutData_ResponsivenessBehaviour,
  LayoutData_DesignTarget,
  Link_Target,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
  PollData_Design_PollDesign_Background_Type,
  PollData_Layout_PollLayout_Direction,
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole,
  SmartBlockData_ColumnSize,
  SmartBlockData_Orientation,
  SmartBlockData_Type,
  SmartBlockCellData_Type,
  TextStyle_TextAlignment,
  TocData_Indentation,
  TocData_ListStyle,
  VerticalAlignment,
  LayoutData_BannerPosition,
  LayoutData_BannerOrigin,
  validateRicosDocument
} from "./ricos-types/next/index.js";
import {
  ToolbarType,
  RicosPluginToolbarNames
} from "./ricos-types/next/index.js";
const RicosEditor = _RicosEditor;
import { RicosViewer } from "./ricos-viewer-next/index.js";
const RicosEditorApiContext = _RicosEditorApiContext;
const RicosEditorApiProvider = _RicosEditorApiProvider;
const useRicosEditorApi = _useRicosEditorApi;
const withRicosEditorApi = _withRicosEditorApi;
const createEmptyContent = _createEmptyContent;
const ensureContentId = _ensureContentId;
const fromPlainText = _fromPlainText;
const fromCKEditorHtml = _fromCKEditorHtml;
const fromRichTextHtml = _fromRichTextHtml;
const translateContent = _translateContent;
const truncateRichContent = _truncateRichContent;
const truncateContent = _truncateContent;
const getContentLength = _getContentLength;
const getMediaData = _getMediaData;
const getPluginData = _getPluginData;
const getText = _getText;
const toHtml = _toHtml;
const toPlainText = _toPlainText;
const toPlainTextSync = _toPlainTextSync;
const toTranslatables = _toTranslatables;
function isRichContent(content) {
  return _isRichContent(content);
}
const isRichContentEmpty = _isRichContentEmpty;
const isRichContentEqual = _isRichContentEqual;
const modify = _modify;
import { readYXmlFragment, writeYXmlFragment } from "./plugin-collab/y-adapter.js";
import {
  ACTION_BUTTON_TYPE,
  AUDIO_TYPE,
  CODE_BLOCK_TYPE,
  COLLAPSIBLE_LIST_TYPE,
  compare,
  createContent,
  DIVIDER_TYPE,
  EMBED_TYPE,
  EMOJI_TYPE,
  EXTERNAL_MENTIONS_TYPE,
  FILE_UPLOAD_TYPE,
  GALLERY_TYPE,
  getTextDirection,
  GIPHY_TYPE,
  HASHTAG_TYPE,
  HEADINGS_DROPDOWN_TYPE,
  HTML_TYPE,
  IMAGE_TYPE,
  INDENT_TYPE,
  isContentStateEmpty,
  LINE_SPACING_TYPE,
  LINK_BUTTON_TYPE,
  LINK_PREVIEW_TYPE,
  LINK_TYPE,
  MENTION_TYPE,
  POLL_TYPE,
  RICOS_ANCHOR_TYPE,
  RICOS_CAPTION_TYPE,
  RICOS_DIVIDER_TYPE,
  RICOS_FILE_TYPE,
  RICOS_GALLERY_TYPE,
  RICOS_GIPHY_TYPE,
  RICOS_IMAGE_TYPE,
  RICOS_LINK_BUTTON_TYPE,
  RICOS_LINK_PREVIEW_TYPE,
  RICOS_LINK_TYPE,
  RICOS_MENTION_TYPE,
  RICOS_POLL_TYPE,
  RICOS_SHAPE_TYPE,
  RICOS_VERTICAL_EMBED_TYPE,
  RICOS_VIDEO_TYPE,
  SHAPE_TYPE,
  SPOILER_TYPE,
  TABLE_TYPE,
  TOC_TYPE,
  TEXT_COLOR_TYPE,
  TEXT_HIGHLIGHT_TYPE,
  TIPTAP_SHAPE_TYPE,
  Version,
  VERTICAL_EMBED_TYPE,
  VIDEO_TYPE
} from "./ricos-content/index.js";
import { extractMedia } from "./ricos-content/lib/extract-media.js";
const extract = _extract;
const createParagraphNode = _createParagraphNode;
const createTextNode = _createTextNode;
const initializeMetadata = _initializeMetadata;
const setupContentBuilder = _setupContentBuilder;
const getCountableNodes = _getCountableNodes;
import { extractUoUParams } from "./_shared/extract-uou-params.js";
import { parseInstance } from "./_shared/request-service-provider/parse-instance.js";
const getInitialLinkData = _getInitialLinkData;
import { resolveFileUrl } from "./ricos-media/index.js";
const getAnchorableNodesQuery = _getAnchorableNodesQuery;
const convertItemData = _convertItemData;
import { getAbsoluteUrl } from "./_shared/media/get-absolute-url.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./_shared/plugin-toolbar/plugin-toolbar-buttons-ids.js";
import { quickStartViewerPlugins } from "./_shared/quick-start-viewer-plugins/quick-start-viewer-plugins.js";
import { generateKey, isHexColor } from "./wix-rich-content-common/index.js";
import { Tooltip } from "./wix-rich-content-common/lib/tooltip.js";
import {
  RicosWidget
} from "./ui-components/wixel-assistant/ricos-assistant-widget.js";
import {
  BUTTON_TYPES,
  FORMATTING_BUTTONS,
  INSERT_PLUGIN_BUTTONS
} from "./editor-common/index.js";
import { pluginAiSuggestions } from "./plugin-ai-suggestions/options.js";
import { pluginCollab } from "./plugin-collab/options.js";
import { pluginAi } from "./plugin-ai/index.js";
import { audioButtonsTypes } from "./plugin-audio/index.js";
const pluginAudio = _pluginAudio;
const pluginAudioViewer = _pluginAudioViewer;
const pluginLinkButton = _pluginLinkButton;
const pluginActionButton = _pluginActionButton;
const pluginActionButtonViewer = _pluginActionButtonViewer;
const pluginLinkButtonViewer = _pluginLinkButtonViewer;
import { pluginCodeBlock } from "./plugin-code-block/index.js";
const pluginCodeBlockViewer = _pluginCodeBlockViewer;
import { pluginCollapsibleList } from "./plugin-collapsible-list/index.js";
const pluginCollapsibleListViewer = _pluginCollapsibleListViewer;
import { DIVIDER_BUTTONS } from "./plugin-divider/index.js";
const pluginDivider = _pluginDivider;
const pluginDividerViewer = _pluginDividerViewer;
const pluginEmoji = _pluginEmoji;
const pluginEmojiViewer = _pluginEmojiViewer;
import {
  pluginFileUpload
} from "./plugin-file-upload/index.js";
import {
  fileExtensionToType,
  FileTypes
} from "./plugin-file-upload/lib/file-extension-to-type.js";
const pluginFileUploadViewer = _pluginFileUploadViewer;
import { pluginFontFamily } from "./plugin-font-family/index.js";
const pluginFontFamilyViewer = _pluginFontFamilyViewer;
import {
  pluginGallery
} from "./plugin-gallery/index.js";
const pluginGalleryViewer = _pluginGalleryViewer;
const pluginGiphy = _pluginGiphy;
const pluginGiphyViewer = _pluginGiphyViewer;
const pluginHashtag = _pluginHashtag;
const pluginHashtagViewer = _pluginHashtagViewer;
const pluginHeadings = _pluginHeadings;
import { htmlButtonsTypes, pluginHtml } from "./plugin-html/index.js";
const pluginHtmlViewer = _pluginHtmlViewer;
const pluginImage = _pluginImage;
const pluginImageViewer = _pluginImageViewer;
import { pluginIndent } from "./plugin-indent/index.js";
const pluginIndentViewer = _pluginIndentViewer;
import { pluginInlineAi } from "./plugin-inline-ai/index.js";
import { pluginLineSpacing } from "./plugin-line-spacing/index.js";
const pluginLineSpacingViewer = _pluginLineSpacingViewer;
import { pluginLink } from "./plugin-link/index.js";
const pluginLinkViewer = _pluginLinkViewer;
import { LinkPreviewProviders } from "./plugin-link-preview/index.js";
const pluginLinkPreview = _pluginLinkPreview;
const pluginLinkPreviewViewer = _pluginLinkPreviewViewer;
import {
  pluginMentions
} from "./plugin-mentions/index.js";
const pluginMentionsViewer = _pluginMentionsViewer;
import { pluginShape, SHAPE_RICOS_DEFAULTS } from "./plugin-shape/index.js";
const pluginShapeViewer = _pluginShapeViewer;
import { pluginSmartBlock } from "./plugin-smart-block/index.js";
const pluginSmartBlockViewer = _pluginSmartBlockViewer;
import {
  pluginPoll
} from "./plugin-social-polls/index.js";
const pluginPollViewer = _pluginPollViewer;
import { pluginSpoiler, SpoilerEditorWrapper } from "./plugin-spoiler/index.js";
const initSpoilersContentState = _initSpoilersContentState;
const pluginSpoilerViewer = _pluginSpoilerViewer;
const SpoilerViewerWrapper = _SpoilerViewerWrapper;
import { TABLE_BUTTONS } from "./plugin-table/index.js";
const pluginTable = _pluginTable;
const pluginTableViewer = _pluginTableViewer;
import { pluginToc } from "./plugin-toc/index.js";
const pluginTocViewer = _pluginTocViewer;
const pluginTextColor = _pluginTextColor;
const pluginTextHighlight = _pluginTextHighlight;
const pluginTextColorViewer = _pluginTextColorViewer;
const pluginTextHighlightViewer = _pluginTextHighlightViewer;
import {
  pluginVerticalEmbed,
  verticalEmbedProviders
} from "./plugin-vertical-embed/index.js";
const pluginVerticalEmbedViewer = _pluginVerticalEmbedViewer;
import {
  pluginVideo,
  videoButtonsTypes
} from "./plugin-video/index.js";
const pluginVideoViewer = _pluginVideoViewer;
import {
  TextSelectionToolbar,
  TwitterButton
} from "./text-selection-toolbar/index.js";
export {
  ACTION_BUTTON_TYPE,
  AUDIO_TYPE,
  AppEmbedData_AppType,
  BUTTON_TYPES,
  ButtonData_Type,
  CODE_BLOCK_TYPE,
  COLLAPSIBLE_LIST_TYPE,
  CollapsibleListData_Direction,
  CollapsibleListData_InitialExpandedItems,
  DIVIDER_BUTTONS,
  DIVIDER_TYPE,
  SchemaDecoration_Type as Decoration_Type,
  DividerData_Alignment,
  DividerData_LineStyle,
  DividerData_Width,
  EMBED_TYPE,
  EMOJI_TYPE,
  EXTERNAL_MENTIONS_TYPE,
  FILE_UPLOAD_TYPE,
  FORMATTING_BUTTONS,
  FileTypes,
  FontSizeData_fontType,
  GALLERY_TYPE,
  GIFData_GIFType,
  GIPHY_TYPE,
  GalleryOptions_ItemStyle_Crop,
  GalleryOptions_Layout_Orientation,
  GalleryOptions_Layout_Type,
  GalleryOptions_Thumbnails_Alignment,
  HASHTAG_TYPE,
  HEADINGS_DROPDOWN_TYPE,
  HTMLData_Source,
  HTML_TYPE,
  IMAGE_TYPE,
  INDENT_TYPE,
  INSERT_PLUGIN_BUTTONS,
  LINE_SPACING_TYPE,
  LINK_BUTTON_TYPE,
  LINK_PREVIEW_TYPE,
  LINK_TYPE,
  LayoutData_BannerOrigin as LayoutData_Banner_Origin,
  LayoutData_BannerPosition as LayoutData_Banner_Position,
  LayoutData_DesignTarget,
  LayoutData_ResponsivenessBehaviour,
  VerticalAlignment as LayoutData_VerticalAlignment_Alignment,
  LinkPreviewProviders,
  Link_Target,
  MENTION_TYPE,
  RicosDocumentNodeType as Node_Type,
  PLUGIN_TOOLBAR_BUTTON_ID,
  POLL_TYPE,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type,
  PollData_Design_PollDesign_Background_Type,
  PollData_Layout_PollLayout_Direction,
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole,
  RICOS_ANCHOR_TYPE,
  RICOS_CAPTION_TYPE,
  RICOS_DIVIDER_TYPE,
  RICOS_FILE_TYPE,
  RICOS_GALLERY_TYPE,
  RICOS_GIPHY_TYPE,
  RICOS_IMAGE_TYPE,
  RICOS_LINK_BUTTON_TYPE,
  RICOS_LINK_PREVIEW_TYPE,
  RICOS_LINK_TYPE,
  RICOS_MENTION_TYPE,
  RICOS_POLL_TYPE,
  RICOS_SHAPE_TYPE,
  RICOS_VERTICAL_EMBED_TYPE,
  RICOS_VIDEO_TYPE,
  RichContent,
  RicosEditor,
  RicosEditorApiContext,
  RicosEditorApiProvider,
  RicosPluginToolbarNames,
  RicosViewer,
  RicosWidget,
  SHAPE_RICOS_DEFAULTS,
  SHAPE_TYPE,
  SPOILER_TYPE,
  SmartBlockCellData_Type,
  SmartBlockData_ColumnSize,
  SmartBlockData_Orientation,
  SmartBlockData_Type,
  SpoilerEditorWrapper,
  SpoilerViewerWrapper,
  TABLE_BUTTONS,
  TABLE_TYPE,
  TEXT_COLOR_TYPE,
  TEXT_HIGHLIGHT_TYPE,
  TIPTAP_SHAPE_TYPE,
  TOC_TYPE,
  TextSelectionToolbar,
  TextStyle_TextAlignment,
  TocData_Indentation,
  TocData_ListStyle,
  ToolbarType,
  Tooltip,
  TwitterButton,
  VERTICAL_EMBED_TYPE,
  VIDEO_TYPE,
  Version,
  audioButtonsTypes,
  compare,
  convertItemData,
  createContent,
  createEmptyContent,
  createParagraphNode,
  createTextNode,
  ensureContentId,
  extract,
  extractMedia,
  extractUoUParams,
  fileExtensionToType,
  fromCKEditorHtml,
  fromPlainText,
  fromRichTextHtml,
  generateKey,
  getAbsoluteUrl,
  getAnchorableNodesQuery,
  getContentLength,
  getCountableNodes,
  getInitialLinkData,
  getMediaData,
  getPluginData,
  getText,
  getTextDirection,
  htmlButtonsTypes,
  initSpoilersContentState,
  initializeMetadata,
  isContentStateEmpty,
  isHexColor,
  isRichContent,
  isRichContentEmpty,
  isRichContentEqual,
  modify,
  parseInstance,
  pluginActionButton,
  pluginActionButtonViewer,
  pluginAi,
  pluginAiSuggestions,
  pluginAudio,
  pluginAudioViewer,
  pluginCodeBlock,
  pluginCodeBlockViewer,
  pluginCollab,
  pluginCollapsibleList,
  pluginCollapsibleListViewer,
  pluginDivider,
  pluginDividerViewer,
  pluginEmoji,
  pluginEmojiViewer,
  pluginFileUpload,
  pluginFileUploadViewer,
  pluginFontFamily,
  pluginFontFamilyViewer,
  pluginGallery,
  pluginGalleryViewer,
  pluginGiphy,
  pluginGiphyViewer,
  pluginHashtag,
  pluginHashtagViewer,
  pluginHeadings,
  pluginHtml,
  pluginHtmlViewer,
  pluginImage,
  pluginImageViewer,
  pluginIndent,
  pluginIndentViewer,
  pluginInlineAi,
  pluginLineSpacing,
  pluginLineSpacingViewer,
  pluginLink,
  pluginLinkButton,
  pluginLinkButtonViewer,
  pluginLinkPreview,
  pluginLinkPreviewViewer,
  pluginLinkViewer,
  pluginMentions,
  pluginMentionsViewer,
  pluginPoll,
  pluginPollViewer,
  pluginShape,
  pluginShapeViewer,
  pluginSmartBlock,
  pluginSmartBlockViewer,
  pluginSpoiler,
  pluginSpoilerViewer,
  pluginTable,
  pluginTableViewer,
  pluginTextColor,
  pluginTextColorViewer,
  pluginTextHighlight,
  pluginTextHighlightViewer,
  pluginToc,
  pluginTocViewer,
  pluginVerticalEmbed,
  pluginVerticalEmbedViewer,
  pluginVideo,
  pluginVideoViewer,
  quickStartViewerPlugins,
  readYXmlFragment,
  resolveFileUrl,
  setupContentBuilder,
  toHtml,
  toPlainText,
  toPlainTextSync,
  toTranslatables,
  translateContent,
  truncateContent,
  truncateRichContent,
  useRicosEditorApi,
  validateRicosDocument,
  verticalEmbedProviders,
  videoButtonsTypes,
  withRicosEditorApi,
  writeYXmlFragment
};
//# sourceMappingURL=index.js.map
